/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const RoundedChatsIconOutline = createIcon({
  displayName: 'RoundedChatsIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.078,21.808c2.708,0 4.904,-2.196 4.904,-4.904c0,-2.708 -2.195,-4.904 -4.904,-4.904c-2.709,0 -4.904,2.196 -4.904,4.904"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.083,21.813c-0.738,0 -1.437,-0.163 -2.065,-0.454l-3.018,0.641l0.631,-3.024c-0.293,-0.63 -0.457,-1.332 -0.457,-2.072"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.557,12.028c-0.358,-0.821 -0.557,-1.716 -0.557,-2.655c0,-4.017 3.598,-7.24 8,-7.24c4.402,0 8,3.223 8,7.24c0,2.374 -1.262,4.464 -3.199,5.782c0.001,0.756 -0.001,1.775 -0.001,2.845l-3.139,-1.546c-0.537,0.103 -1.092,0.159 -1.661,0.159c-0.707,0 -1.393,-0.084 -2.047,-0.241"
        ></path>
      </g>
    </>
  ),
})

const RoundedChatsIconTwoTone = createIcon({
  displayName: 'RoundedChatsIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneLightColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.557,12.028c-0.358,-0.821 -0.557,-1.716 -0.557,-2.655c0,-4.017 3.598,-7.24 8,-7.24c4.402,0 8,3.223 8,7.24c0,2.374 -1.262,4.464 -3.199,5.782c0.001,0.756 -0.001,1.775 -0.001,2.845l-3.139,-1.546c-0.537,0.103 -1.092,0.159 -1.661,0.159c-0.707,0 -1.393,-0.084 -2.047,-0.241"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.083,21.813c-0.738,0 -1.437,-0.163 -2.065,-0.454l-3.018,0.641l0.631,-3.024c-0.293,-0.63 -0.457,-1.332 -0.457,-2.072"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.078,21.808c2.708,0 4.904,-2.196 4.904,-4.904c0,-2.708 -2.195,-4.904 -4.904,-4.904c-2.709,0 -4.904,2.196 -4.904,4.904"
        ></Box>
      </g>
    </>
  ),
})

const RoundedChats: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={RoundedChatsIconTwoTone} {...props} />
    default:
      return <CustomIcon as={RoundedChatsIconOutline} {...props} />
  }
}

export default memo(RoundedChats)
